/* eslint-disable react-refresh/only-export-components -- провайдер и его хук
   живут вместе: контекст между ними не должен утекать наружу. */
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'
import { Gap, GapNote, GapRow, type GapBlockProps, type GapProps } from '@dorixona/ui'
import { env } from '../config/env'

/* Пометки выключены — места, которые держатся только на них (плитка без
   значения, колонка без данных), прячутся целиком, а не стоят пустыми. */
document.documentElement.toggleAttribute('data-gaps-off', !env.showApiGaps)

/**
 * Пометки «нет в API» в приложении покупателя.
 *
 * В админке такая пометка адресована сотруднику, и она видна всегда. Здесь
 * экран видит покупатель, которому нечего знать про наши ручки, — поэтому
 * пометки показываются на стенде и в разработке, а в продовой сборке
 * выключаются (`VITE_SHOW_API_GAPS`). Скрытое место при этом не притворяется
 * готовым: без пометки оно просто не показывается вовсе.
 */
const GapsContext = createContext<boolean | null>(null)

export interface GapsProviderProps {
  children: ReactNode
  /** Тест включает и выключает пометки, не трогая переменные окружения. */
  show?: boolean
}

export function GapsProvider({ children, show = env.showApiGaps }: GapsProviderProps) {
  return <GapsContext.Provider value={show}>{children}</GapsContext.Provider>
}

export function useGapsShown(): boolean {
  return useContext(GapsContext) ?? env.showApiGaps
}

/** Метка в строке текста. */
export function ApiGap(props: GapProps) {
  return useGapsShown() ? <Gap {...props} /> : null
}

/** Строка «показатель → значение», значения для которой нет. */
export function ApiGapRow(props: GapProps) {
  return useGapsShown() ? <GapRow {...props} /> : null
}

/** Пояснение под разделом. */
export function ApiGapNote(props: GapBlockProps) {
  return useGapsShown() ? <GapNote {...props} /> : null
}
